export const DEFAULT_TITLE = 'Live - Quadia';

export const setTitle = (content) => {
    const title = document.head.querySelector('title');
    title.innerText = content;
};